import React from 'react';
import { DBGWithType } from '~modules/devices/components/DeviceHealthTable/types';
import {
  findMeAction,
  powerOffAction,
  rebootAction,
  sendMessageAction,
} from '~components/Tables/DeviceTables/deviceTableActions';
import { TableRowAction } from '~components/Tables/DeviceTables/hooks/useTableRowActions';
import { DeviceCommandModal } from '~modules/devices/components/DeviceModals/DeviceCommandModal';
import { DeviceCommand } from '~modules/devices/api/deviceCommands';

/** Remote commands (reboot, message, find me, power off), for the device types that take them: Twig and Eview. */
export function useDeviceCommandActions({ canCommand }: { canCommand: boolean }) {
  const [pending, setPending] = React.useState<{ action: DeviceCommand['action']; devices: DBGWithType[] }>();

  const actions: TableRowAction<DBGWithType>[] = canCommand
    ? [
        rebootAction((devices) => setPending({ action: 'reboot', devices })),
        sendMessageAction((devices) => setPending({ action: 'message', devices })),
        findMeAction((devices) => setPending({ action: 'find_me', devices })),
        powerOffAction((devices) => setPending({ action: 'power_off', devices })),
      ]
    : [];

  const modals = pending && (
    <DeviceCommandModal devices={pending.devices} action={pending.action} onClose={() => setPending(undefined)} />
  );

  return { actions, modals };
}
